<template>
  <PageLayout>
    <template #headerTitle> Transactions </template>
    <TransactionList />
  </PageLayout>
</template>
